import { render, staticRenderFns } from "./SettingTitle.pug?vue&type=template&id=43dac206&scoped=true&lang=pug&"
import script from "./SettingTitle.vue?vue&type=script&lang=js&"
export * from "./SettingTitle.vue?vue&type=script&lang=js&"
import style0 from "./SettingTitle.scss?vue&type=style&index=0&id=43dac206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dac206",
  null
  
)

export default component.exports